// Nodes API module

import { apiRequest } from '../services/api';

export interface Node {
  id: string;
  name: string;
  location: string;
  flag: string;
  host: string;
  port: number;
  public_host: string;
  status: string;
  last_heartbeat: string;
  last_ping: number;
  max_tunnels: number;
  active_tunnels: number;
  cpu_usage: number;
  memory_usage: number;
  disk_usage: number;
  version: string;
  created_at: string;
  updated_at: string;
}

/**
 * Nodes API client - uses centralized apiRequest for proper authentication
 */
export const nodesAPI = {
  /**
   * Get all available nodes
   * @returns List of available nodes
   */
  getAvailable: (): Promise<Node[]> =>
    apiRequest<Node[]>('/v1/nodes/available'),
};
